import {PlaneList} from "./PlaneList";
import {Perspective} from "./Perspective";
import {http_request} from "../../httpConfig";

export function Photo() {
    this.namespaced = true;
    this.state = {
        src: '',
        shadowMaskSRC: '',
        constructorName: 'Photo',
        name: null,
        scale: null,
        size: null,
    };

    this.getters = {
        NAME: state => {
            return state.name;
        },
        SCALE: state => {
            return state.scale;
        },
        CHECK_SCAlE_PHOTO: state => {
            return !!state.scale;
        }
    };

    this.mutations = {
        INIT: (state, data) => {
            state.src = data.src;
            if (data.scale) state.scale = data.scale;
            if (data.shadowMaskSRC) state.shadowMaskSRC = data.shadowMaskSRC;
        },
        SRC: (state, src) => {
            state.src = src;
        },
        NAME: (state, newName) => {
            state.name = newName;
        },
        SCALE: (state, scale) => {
            state.scale = scale;
        },
        SHADOW_MASK: (state, src) => {
        state.shadowMaskSRC = src;
        },
        SIZE: (state, size) => {
            state.size = size;
        }
    };

    this.actions = {
        INIT: function (context, inputData) {
            const photoData = inputData.data;
            const pathPhoto = inputData.path;
            // const preserveState = inputData.preserveState;
            const pathPlaneList = pathPhoto.concat(['planeList']);
            this.registerModule(pathPlaneList, new PlaneList());
            const pathPerspective = pathPhoto.concat(['perspective']);
            this.registerModule(pathPerspective, new Perspective());
            context.commit('INIT', photoData);
        },
        GET_SHADOW_MASK: function (context) {
            let requestPromise = ()=> {
                const reqPromise = new Promise((resolve) => {
                    http_request.post('/get_shadows_map', {image_src: context.state.src})
                        .then((request) => {
                            console.log("reqest shadow ", request.data.uuid_filename)
                            context.commit('SHADOW_MASK', request.data.uuid_filename);
                            resolve(request.data.uuid_filename)
                        })
                        .catch((error) => {
                            console.error(error);
                            resolve();
                        })
                });

                context.dispatch('IN_PROGRESS', reqPromise, {root: true});
                return reqPromise
            }

            if (context.state.shadowMaskSRC) {
                return fetch(context.rootGetters[`projectConfiguration/GENERATE_URL`](context.state.shadowMaskSRC), {method: 'HEAD'}).then(res => {
                    if (res.ok) {
                        return context.state.shadowMaskSRC;
                    } else {
                        console.error("Image not found on server ", context.state.shadowMaskSRC)
                        return requestPromise()
                    }
                })
            }
            else {
                return requestPromise()
            }

        }
    };
}
